import React from 'react';
import { Route } from 'react-router-dom';
import Employeecard from '../../Employeedata/Employeecard.js';
import TicketForm from '../../Employeedata/EmployeeFiles/EnterTicketForm.js';
import EmployeeList from '../../Employeedata/EmployeeFiles/EmployeeTicketsList.js';
import EmployeeDataAllList from '../../Employeedata/EmployeeFiles/EmployeeDataAllList.js';
import SOP from '../../Employeedata/EmployeeFiles/SOP-data.js';
import SOPPOST from '../../Employeedata/EmployeeFiles/SOP-post.js';
import Employeedaterange from '../../Employeedata/EmployeeFiles/Employedatedaterange.js';
import LeaveCard from '../../Leave-data/leavecard.js';
import Applyleave from '../../Leave-data/Leave-data-files/Leave-Post.js';
import Getleavedata from '../../Leave-data/Leave-data-files/leavaedata-get.js';
import LeaveStatus from '../../Leave-data/Leave-data-files/Leave-status.js';
import { guardRoute } from '../ProtectedRoute';

export const employeeLeaveRoutes = [
  <Route
    key="employeecard"
    path="/Employeecard"
    element={guardRoute(<Employeecard />, '/Employeecard')}
  />,
  <Route key="ticket-form" path="/TicketForm" element={guardRoute(<TicketForm />, '/TicketForm')} />,
  <Route
    key="employee-list"
    path="/EmployeeList"
    element={guardRoute(<EmployeeList />, '/EmployeeList')}
  />,
  <Route
    key="employee-data-all"
    path="/employee-data/all"
    element={guardRoute(<EmployeeDataAllList />, '/employee-data/all')}
  />,
  <Route key="sop" path="/SOP" element={guardRoute(<SOP />, '/SOP')} />,
  <Route key="sop-post" path="/SOP-POST" element={guardRoute(<SOPPOST />, '/SOP-POST')} />,
  <Route
    key="employee-date-range"
    path="/EmployeeDateRange"
    element={guardRoute(<Employeedaterange />, '/EmployeeDateRange')}
  />,
  <Route key="leave-card" path="/LeaveCard" element={guardRoute(<LeaveCard />, '/LeaveCard')} />,
  <Route key="apply-leave" path="/Applyleave" element={guardRoute(<Applyleave />, '/Applyleave')} />,
  <Route
    key="get-leave-data"
    path="/Getleavedata"
    element={guardRoute(<Getleavedata />, '/Getleavedata')}
  />,
  <Route key="leave-status" path="/LeaveStatus" element={guardRoute(<LeaveStatus />, '/LeaveStatus')} />,
];
